module.exports = ".logo {\n  width: 100px;\n  cursor: pointer; }\n\n.btn-back {\n  cursor: pointer; }\n\n.header-logo {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/header/header.component.scss
// module id = ./src/app/components/shared/header/header.component.scss
// module chunks = main